import { Component, ChangeDetectionStrategy } from '@angular/core';

import { HeaderBaseComponent } from '@resident-nx/shared';

@Component({
  selector: 'rs-web-header-old',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: 'header-old.component.html',
})
export class HeaderWebOldComponent extends HeaderBaseComponent {}
